import { decision1 } from '../assets';

export const projects = [
  {
    id: '1',
    name: 'Decision Maker',
    text: 'Decision Maker is a full-stack decision support application that helps users evaluate options objectively using weighted scoring.',
    image: decision1,
    style:
      'flex flex-col md:flex-row justify-between lg:justify-evenly items-start md:items-center bg-gray-800 dark:bg-black3 dark:bg-gradient-to-tl from-black3 from-[0%] via-black3 to-[#5b3de6]',
  },
  // {
  //   id: '2',
  //   name: 'Job Finder Application',
  //   text: 'Jobit is a web-based application for job posting that my team and I created using React and JSearch API. Our platform connects developers with millions of job opportunities for free...',
  //   image: jobitSlide1,
  //   style:
  //     'flex flex-col md:flex-row justify-between lg:justify-evenly items-start md:items-center bg-[#09AB7C] dark:bg-black3 dark:bg-gradient-to-tl from-black3 from-[0%] via-black3 to-[#09AB7C]',
  // },
  // {
  //   id: '3',
  //   name: 'Car Renting Application',
  //   text: 'Morent, a cutting-edge car rental application that was developed using the MERN stack. The app boasts a dynamic homepage that showcases featured vehicles...',
  //   image: morentSlide1,
  //   style:
  //     'flex flex-col md:flex-row xl:flex-row-reverse justify-between lg:justify-evenly items-start md:items-center bg-[#3563E9] dark:bg-black3 dark:bg-gradient-to-br from-black3 from-[0%] via-black3 to-[#3563E9]',
  // },
];
